import DateUtils from '@/utils/date'

export default {
  // 获取精确到分的日期时间范围
  getNormMinuteRangeFilter: DateUtils.getNormMinuteRange,
  // 精确到日期
  getNormDayFilter: DateUtils.getNormDay,
  // 精确到分钟
  getNormMinuteFilter: DateUtils.getNormMinute
}
